<template>
  <div>
    <b-row>
      <b-col>
        <ArticleImage
          :validator="$validator"
          isEdit
          :file="file"
          :urlProps="item.image"
          label="Image"
          name="image"
          validateRule="minimalDimensions:1000,500|ratiolDimensions:2,1|size:2000|ext:jpg,png,gif,jpeg"
          @onFileChange="(val) => file = val"
          @onUrlChange="(val) => url = val"
        />
        <br>
        <ArticleImage
          :validator="$validator"
          isEdit
          :file="file_webp"
          :urlProps="item.image_webp"
          label="WEBP Image"
          name="image_webp"
          validateRule="minimalDimensions:1000,500|ratiolDimensions:2,1|size:2000|ext:webp"
          @onFileChange="(val) => file_webp = val"
        >
          <template v-slot:desc>
            <p class="text-gray-500">
              Image must be at least 1000x500 pixels and maximum 2MB. Must be in <b>WEBP</b> format
            </p>
          </template>
        </ArticleImage>
        <br>
        <ArticleImage
          :validator="$validator"
          isEdit
          :file="file_mobile"
          :urlProps="item.image_mobile"
          label="Mobile App Image"
          name="image_mobile"
          :validateRule="`size:2000|ext:jpg,png,gif,jpeg|${item.category === 'pusatinformasipaxel' ? 'ratiolDimensions:4,5' : 'ratiolDimensions:2,1'}`"
          @onFileChange="(val) => file_mobile = val"
        >
          <template v-slot:desc>
            <p class="text-gray-500">
              Image must be maximum 2MB. Must be in {{item.category === 'pusatinformasipaxel' ? '4:5' : '2:1'}} Ratio. Must be in <b>JPEG</b>, <b>PNG</b>,
              or <b>GIF</b> format
            </p>
          </template>
        </ArticleImage>
        <br>
        <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Image Alt Text"
            label-for="input-1"
          >
            <input
              id="input-1"
              type="text"
              class="form-control"
              v-validate="this.item.category === 'pejuangonline' ? 'required|max:70' : 'required|max:159'"
              name="image_alt"
              data-vv-as="Image Alt Text"
              v-model="item.image_alt"
              placeholder="Image Alt Text"
            />
            <b-form-invalid-feedback
              id="input-image_alt-feedback"
            >{{ veeErrors.first('image_alt') }}</b-form-invalid-feedback>
          </b-form-group>
        <br />
        <b-form-group
            id="input-group-1"
            label-class="control-label"
            label="Mobile Redirection URL"
            label-for="input-1"
          >
            <input
              id="input-1"
              type="text"
              class="form-control"
              name="mobile_redirect_url"
              v-model="item.mobile_redirect_url"
              placeholder="Mobile Redirection URL"
            />
          </b-form-group>
        <br />
        <label class="text-danger">
          *
          <b class="text-dark">Required</b>
        </label>
      </b-col>
      <b-col md="8">
        <b-row v-show="item.category === 'promo'">
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="Promo Code"
              label-for="input-1"
            >
              <input
                v-if="item.promo_product_roles"
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'alpha_num'"
                name="promo_code"
                v-model="item.promo_product_roles.promo_code"
                placeholder="Promo Code"
              />
              <b-form-invalid-feedback
                id="input-promo_code-feedback"
              >{{ veeErrors.first('promo_code') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title in Bahasa"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="this.item.category === 'pejuangonline' ? 'required|max:70' : 'required|max:159'"
                name="title_id"
                v-model="item.title.id"
                data-vv-as="Title in Bahasa"
                placeholder="Title in Bahasa"
                :class="{ 'is-invalid': veeErrors.has('title_id') }"
                @input="clearTitleErrors"
              />
              <b-form-invalid-feedback
                id="input-title_id-feedback"
              >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title in English"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="this.item.category === 'pejuangonline' ? 'required|max:70' : 'required|max:159'"
                name="title_en"
                v-model="item.title.en"
                data-vv-as="Title in English"
                placeholder="Title in English"
                :class="{ 'is-invalid': veeErrors.has('title_en') }"
                @input="clearTitleErrors"
              />
              <b-form-invalid-feedback
                id="input-title_en-feedback"
              >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Quick / Meta Description Bahasa (Max : 159 karakter)"
              label-for="input-1"
            >
              <textarea
                id="input-1"
                type="text"
                class="form-control"
                v-validate="{required: true, max: 159}"
                name="meta_description_id"
                data-vv-as="Quick / Meta Description Bahasa"
                v-model="item.meta_description.id"
                placeholder="Quick / Meta Description Bahasa"
                style="height: 70px"
              />
              <b-form-invalid-feedback
                id="input-meta_description_id-feedback"
              >{{ veeErrors.first('meta_description_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Quick / Meta Description English (Max : 159 karakter)"
              label-for="input-1"
            >
              <textarea
                id="input-1"
                type="text"
                class="form-control"
                v-validate="{required: true, max: 159}"
                name="meta_description_en"
                data-vv-as="Quick / Meta Description English"
                v-model="item.meta_description.en"
                placeholder="Quick / Meta Description English"
                style="height: 70px"
              />
              <b-form-invalid-feedback
                id="input-meta_description_en-feedback"
              >{{ veeErrors.first('meta_description_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="quick-cta-button-fieldset-1" label="Quick CTA Button" label-for="quick-cta-button-1">
              <b-form-radio-group
                id="quick-cta-button-radio-group-1"
                v-model="item.is_with_quick_cta_button"
                :options="options_q_cta"
                name="is_with_quick_cta_button"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="item.is_with_quick_cta_button">
          <br />
          <b-col md="6">
            <b-form-group id="quick-cta-button-fieldset-1" class="required" label-class="control-label" label="Quick CTA Button (Bahasa)" label-for="quick-cta-button-1">
              <input
                id="quick-cta-button-1"
                :disabled="item.is_with_quick_cta_button == false"
                v-model="item.quick_cta_button.text.id"
                v-validate="'required'"
                data-vv-as="Quick CTA Button Bahasa"
                name="quick_cta_button_text_id"
                class="form-control"
                placeholder="Quick CTA Button in Bahasa"
              />
              <b-form-invalid-feedback
                id="input-question_id-feedback"
              >{{ veeErrors.first('quick_cta_button_text_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="quick-cta-button-fieldset-1" class="required" label-class="control-label" label="Quick CTA Button (English)" label-for="quick-cta-button-2">
              <input
                id="quick-cta-button-2"
                :disabled="item.is_with_quick_cta_button == false"
                v-model="item.quick_cta_button.text.en"
                v-validate="'required'"
                data-vv-as="Quick CTA Button English"
                name="quick_cta_button_text_en"
                class="form-control"
                placeholder="Quick CTA Button in English"
              />
              <b-form-invalid-feedback
                id="input-question_id-feedback"
              >{{ veeErrors.first('quick_cta_button_text_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group id="quick-cta-button-fieldset-1" class="required" label-class="control-label" label="Quick CTA Button URL" label-for="quick-cta-button-3">
              <input
                id="quick-cta-button-3"
                type="url"
                :disabled="item.is_with_quick_cta_button == false"
                v-model="item.quick_cta_button.url"
                v-validate="{required: true, url: true}"
                data-vv-as="Quick CTA Button URL"
                name="quick_cta_button_url"
                class="form-control"
                placeholder="Quick CTA Button URL"
              />
              <b-form-invalid-feedback
                id="input-question_id-feedback"
              >{{ veeErrors.first('quick_cta_button_url') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content Bahasa"
              label-for="input-1"
            >
              <summer-note v-model="item.content.id" name="content_id" placeholder="Content Bahasa"></summer-note>
              <input type="hidden" v-model="item.content.id" v-validate="'required'" name="content_id" data-vv-as="Content Bahasa">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_id') }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content English:"
              label-for="input-1"
            >
              <summer-note v-model="item.content.en" name="content_en" placeholder="Content English"></summer-note>
              <input type="hidden" v-model="item.content.en" v-validate="'required'" name="content_en" data-vv-as="Content English">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_en') }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="cta-button-fieldset-1" label="CTA Button" label-for="cta-button-1">
              <b-form-radio-group
                id="cta-button-radio-group-1"
                v-model="item.is_with_cta_button"
                :options="options_cta"
                name="is_with_cta_button"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="item.is_with_cta_button">
          <br />
          <b-col md="6">
            <b-form-group id="cta-button-fieldset-1" class="required" label-class="control-label" label="CTA Button (Bahasa)" label-for="cta-button-1">
              <input
                id="cta-button-1"
                :disabled="item.is_with_cta_button == false"
                v-model="item.cta_button.text.id"
                v-validate="'required'"
                data-vv-as="CTA Button Bahasa"
                name="cta_button_text_id"
                class="form-control"
                placeholder="CTA Button in Bahasa"
              />
              <b-form-invalid-feedback
                id="input-question_id-feedback"
              >{{ veeErrors.first('cta_button_text_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="cta-button-fieldset-1" class="required" label-class="control-label" label="CTA Button (English)" label-for="cta-button-2">
              <input
                id="cta-button-2"
                :disabled="item.is_with_cta_button == false"
                v-model="item.cta_button.text.en"
                v-validate="'required'"
                data-vv-as="CTA Button English"
                name="cta_button_text_en"
                class="form-control"
                placeholder="CTA Button in English"
              />
              <b-form-invalid-feedback
                id="input-question_id-feedback"
              >{{ veeErrors.first('cta_button_text_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group id="cta-button-fieldset-1" class="required" label-class="control-label" label="CTA Button URL" label-for="cta-button-3">
              <input
                id="cta-button-3"
                type="url"
                :disabled="item.is_with_cta_button == false"
                v-model="item.cta_button.url"
                v-validate="{required: true, url: true}"
                data-vv-as="CTA Button URL"
                name="cta_button_url"
                class="form-control"
                placeholder="CTA Button URL"
              />
              <b-form-invalid-feedback
                id="input-question_id-feedback"
              >{{ veeErrors.first('cta_button_url') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="fieldset-1" label="Tags">
              <div style="padding:10px;border:0.5px solid #dedede">
                <b-row>
                  <b-col md="8">
                    <vue-auto-complete class="auto-input" placeholder="Tag" v-model="tag"></vue-auto-complete>
                  </b-col>
                  <b-col md="4">
                      <a @click="addTags()" style="text-decoration:none;cursor:pointer">
                        <b-button size="sm" variant="light" style="color:#5e50a1" pill>
                          <i class="fas fa-plus"></i>
                        </b-button> Add tag
                      </a>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col style="flex: 2 1 auto;display: flex;flex-wrap:wrap;">
                    <div v-for="(data,index) in item.tags" :key="data" style="padding:5px;border-radius:5px;margin-right:10px;margin-top:10px;border:0.5px solid #dedede">
                      {{data ? data:''}} <b-button size="sm" variant="light" style="color:#5e50a1" @click="erraseTags(index)" pill>
                          <i class="fas fa-times"></i>
                        </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-form-group>
            <input type="hidden" v-model="item.tags" name="tags" data-vv-as="Tags">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('tags') }}</p>
          </b-col>
        </b-row>
        <b-row v-show="item.category === 'news'">
          <b-col>
            <b-form-checkbox
              id="checkbox-bulk-shipping-rates"
              v-model="item.has_shipping_rates"
              name="checkbox-bulk-shipping-rates"
            >With Shipping Rates</b-form-checkbox>
          </b-col>
        </b-row>
        <br />
        <b-row v-show="item.has_shipping_rates">
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              class="required"
              label="Bulk Shipping Rates:"
              label-for="input-1"
            ></b-form-group>
            <b-card body-class="py-2 px-2">
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Upload File (csv)</b>
                  <sup class="text-secondary pl-3"></sup
                  >
                </b-col>
                <b-col md="8" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileBulkShippingRates"
                    name="bulkShippingRates"
                    data-vv-as="Bulk Shipping Rates"
                    v-validate="'ext:csv'"
                    style="display: none"
                    v-on:change="onChangeFileBulkShippingRates()"
                  />
                  <b-button
                    @click="$refs.fileBulkShippingRates.click()"
                    v-show="!item.shipping_rates.length > 0 && !fileBulkShippingRates"
                    variant="primary"
                    class="mr-2 mt-2"
                    >Pilih File</b-button
                  >
                  <b-button
                    v-show="item.shipping_rates.length > 0"
                    variant="primary"
                    @click="modalBulkShippingRates = !modalBulkShippingRates"
                    class="mr-2 mt-2"
                    >Lihat</b-button
                  >
                  <b-button
                    @click="$refs.fileBulkShippingRates.click()"
                    v-show="item.shipping_rates.length > 0 || fileBulkShippingRates"
                    variant="outline-primary"
                    class="mr-2 mt-2"
                    >Ubah File</b-button
                  >
                  <a href="/template/shipping_rate_template.csv" class="btn btn-outline-primary mt-2" download>
                    Download Template
                  </a>
                </b-col>
              </b-row>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("bulkShippingRates") }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="fieldset-1" label="Start Date" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="20px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="item.periode.start_date"
                    :format="customFormatter"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    align="left"
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row align="left" class="pt-1">
                      <b-col>
                        <b-link @click="resetStardate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="20px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="item.periode.end_date"
                    :format="customFormatter"
                    :disabledDates="disabledPeriodDatesEnd"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    align="left"
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row align="left" class="pt-1">
                      <b-col>
                        <b-link @click="resetEnddate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col></b-col>
        </b-row>
        <br />
        <br />
        <b-row class="mt-2">
          <b-col class="text-left">
              <b-button
                :disabled="loading || isPreviewDisabled"
                @click="previewArticle()"
                class="col-4 mr-3"
                variant="primary"
                size="lg">
                  Preview
              </b-button>
          </b-col>
          <b-col class="text-right">
            <router-link :to="{ name: 'Article' }">
              <b-button :disabled="loading" class="col-4 mr-3" variant="outline-secondary" size="lg">Cancel</b-button>
            </router-link>
            <b-button
              variant="primary"
              :disabled="loading"
              @click="put()"
              class="col-4"
              size="lg"
            >
              Save
              <b-spinner v-if="loading" small label="Loading..."></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal v-model="modalBulkShippingRates" title="Shipping Rates" size="lg">
      <b-row>
        <b-col sm="7" md="6" class="my-1">
          Date: {{item.shipping_rates_date}}
        </b-col>
        <b-table
          responsive
          show-empty
          hover
          :current-page="shippingRatesCurrentPage"
          :per-page="shippingRatesPerPage"
          :items="item.shipping_rates"
          class="bg-white"
        >
        </b-table>
        <b-col sm="7" md="6" class="my-1">
          <b-pagination
            v-model="shippingRatesCurrentPage"
            :total-rows="shippingRatestotal"
            :per-page="shippingRatesPerPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import summerNote from "@/components/Summernote.vue";
import VueAutoComplete from './VueAutocomplete.vue';
import ArticleImage from './ArticleImage.vue'

export default {
  components: {
    Datepicker,
    VueAutoComplete,
    summerNote,
    ArticleImage
  },
  props: ["item"],
  data() {
    return {
      loading: false,
      file: "",
      url: "",
      file_webp: "",
      file_mobile: "",
      InputImage: false,
      widthImage: null,
      heightImage: null,
      tag: "",
      options_q_cta: [
        { text: "No", value: false },
        { text: "Yes", value: true }
      ],
      options_cta: [
        { text: "No", value: false },
        { text: "Yes", value: true }
      ],
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      fileBulkShippingRates: '',
      modalBulkShippingRates: false,
      shippingRatestotal: 0,
      shippingRatesCurrentPage: 1,
      shippingRatesPerPage: 10,
      errorBE: {}
    };
  },
  mounted() {
    // Set the initial number of shipping rates
    this.shippingRatestotal = this.item.shipping_rates.length;
  },
  methods: {
    clearTitleErrors() {
      // Clear backend error object
      this.errorBE = {};
      
      // Remove only backend errors from VeeValidate
      const backendErrors = this.$validator.errors.items.filter(
        error => error.id === 'backend_error' && (error.field === 'title_id' || error.field === 'title_en')
      );
      
      backendErrors.forEach(error => {
        this.$validator.errors.remove(error);
      });
    },
    addTags() {
      if(this.item.tags == null){
        this.item.tags = []
      }
      if (this.tag !== '') {
        this.item.tags.push(this.tag);
        this.tag = "";
      }
    },
    erraseTags(index) {
      this.item.tags.splice(index,1);
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    resetStardate() {
      this.item.periode.start_date = "";
    },
    resetEnddate() {
      this.item.periode.end_date = "";
    },
    put() {
      this.$validator.validateAll().then(result => {
        this.errorBE = {};
        if (result) {
          const formData = new FormData();

          formData.append("category", this.item.category);
          formData.append("image_alt", this.item.image_alt);
          formData.append("mobile_redirect_url", this.item.mobile_redirect_url);
          formData.append("title_id", this.item.title.id);
          formData.append("title_en", this.item.title.en);
          formData.append("content_id", this.item.content.id);
          formData.append("content_en", this.item.content.en);
          formData.append("is_with_quick_cta_button", this.item.is_with_quick_cta_button);
          formData.append("quick_cta_button_text_id", this.item.quick_cta_button.text.id);
          formData.append("quick_cta_button_text_en", this.item.quick_cta_button.text.en);
          formData.append("quick_cta_button_url", this.item.quick_cta_button.url);
          formData.append("is_with_cta_button", this.item.is_with_cta_button);
          formData.append("cta_button_text_id", this.item.cta_button.text.id);
          formData.append("cta_button_text_en", this.item.cta_button.text.en);
          formData.append("cta_button_url", this.item.cta_button.url);
          formData.append("meta_description_id", this.item.meta_description.id);
          formData.append("meta_description_en", this.item.meta_description.en);
          formData.append("image_webp", this.file_webp);
          formData.append("image", this.file);
          formData.append("image_mobile", this.file_mobile);
          if (this.item.category === "news") {
            formData.append("has_shipping_rates", this.item.has_shipping_rates);
            formData.append("bulk_shipping_rates", this.fileBulkShippingRates);
          }
          if (
            this.item.periode.start_date == "" &&
            this.item.periode.end_date != ""
          ) {
            const endDate = moment(this.item.periode.end_date).format(
              "YYYY-MM-DD"
            );
            formData.append("period_start", this.item.periode.start_date);
            formData.append("period_end", endDate);
          }
          if (
            this.item.periode.start_date != "" &&
            this.item.periode.end_date == ""
          ) {
            const startDate = moment(this.item.periode.start_date).format(
              "YYYY-MM-DD"
            );
            formData.append("period_start", startDate);
            formData.append("period_end", this.item.periode.end_date);
          }
          if (
            this.item.periode.start_date != "" &&
            this.item.periode.end_date != ""
          ) {
            const startDate = moment(this.item.periode.start_date).format(
              "YYYY-MM-DD"
            );
            const endDate = moment(this.item.periode.end_date).format(
              "YYYY-MM-DD"
            );

            formData.append("period_start", startDate);
            formData.append("period_end", endDate);
          }
          if (
            this.item.periode.start_date == "" &&
            this.item.periode.end_date == ""
          ) {
            formData.append("period_start", this.item.periode.start_date);
            formData.append("period_end", this.item.periode.end_date);
          }
          if (this.item.category === "promo") {
            formData.append(
              "promo[promo_code]",
              this.item.promo_product_roles.promo_code
            );
          }
          $.each(this.item.tags, (key, value) => {
            formData.append("tags", value);
          });
          this.loading = true;
          this.$store
            .dispatch("ArticleModule/putArticles", {
              id: this.$route.params.id,
              formData
            })
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "Article" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              const errMsg =
                Array.isArray(error.response.data.data) && error.response.data.data.length
                  ? error.response.data.data[0]
                  : error.response.data.message
                  ? error.response.data.message
                  : "Something Went Wrong...";
              if(errMsg.includes("title")) {
                this.$nextTick(() => {
                  // Add to both errorBE and veeErrors
                  this.errorBE.title = errMsg;
                  this.veeErrors.add({
                    field: 'title_id',
                    msg: errMsg,
                    id: 'backend_error'
                  });
                   this.veeErrors.add({
                    field: 'title_en',
                    msg: errMsg,
                    id: 'backend_error'
                  });
                });
              }
              this.$swal({
                type: "error",
                title: "Oops...",
                text: errMsg,
                showConfirmButton: false,
                timer: 1500
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onChangeFileBulkShippingRates() {
      this.fileBulkShippingRates = this.$refs.fileBulkShippingRates.files[0];
      const input = this.$refs.fileBulkShippingRates;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    previewArticle() {
      const data = {
        category: this.item.category,
        image: this.url === "" ? this.item.image : this.url,
        image_alt: this.item.image_alt,
        title: this.item.title.id,
        content: this.item.content.id,
        is_with_quick_cta_button: this.item.is_with_quick_cta_button,
        quick_cta_button_text: this.item.quick_cta_button.text.id,
        quick_cta_button_url: this.item.quick_cta_button.url,
        is_with_cta_button: this.item.is_with_cta_button,
        cta_button_text: this.item.cta_button.text.id,
        cta_button_url: this.item.cta_button.url,
        meta_description: this.item.meta_description.id,
        tags: this.item.tags,
      }
      this.$session.set('previewArticle', data);
      let routePreviewArticle = this.$router.resolve({name: 'previewArticle'});
      window.open(routePreviewArticle.href, '_blank');
    }
  },
  computed: {
    disabledPeriodDatesEnd() {
      const dateEnd = moment(this.item.periode.start_date, "YYYY-MM-DD").toDate();
      var disabledDates = {
        to: new Date(dateEnd - 8640000),
      };
      return disabledDates;
    },
    isPreviewDisabled() {
      let isPreviewDisabled = true;
      if (this.item) {
        isPreviewDisabled = this.item.category === "" ||
          this.item.image === "" ||
          this.item.image_alt === "" ||
          this.item.title.id === "" ||
          this.item.meta_description.id === "" ||
          this.item.content.id === "";
      }
      return isPreviewDisabled;
    }
  }
}
</script>

<style>
</style>
